import axios, { AxiosResponse } from "axios";
import { PettEvaluation } from "@tt-app/models/internal/pett";
import { API_PETT_URL_DEFAULT, API_PETT_KEY_DEFAULT } from "@tt-app/constants";

export const ApiPettURL = process.env.VUE_APP_PETT_API || API_PETT_URL_DEFAULT;
export const ApiPettKey = process.env.VUE_APP_PETT_API_KEY || API_PETT_KEY_DEFAULT;

export class Pett {
  httpClient = axios.create({
    baseURL: ApiPettURL,
    headers: {
      "Access-Control-Allow-Origin": "*",
      "application-key": ApiPettKey
    }
  });

  /**
   * Please check joyz internal documentation for more informaiton on this endpoint
   * @param audio
   * @param transcription
   */
  async sendForEvaluation(audio: Blob, transcription: string): Promise<PettEvaluation> {
    const formData = new FormData();
    formData.append("sounddata", audio);
    formData.append("transcription", transcription);
    formData.append("word_mask_mode", "none");

    const axiosResp: AxiosResponse<PettEvaluation> = await this.httpClient.post("", formData);
    // console.log("PETT Evaluation response", axiosResp.data);
    return axiosResp.data;
  }
}
